import classNames from "classnames";

function Footer({ className }) {
  return (
    <div
      className={classNames(
        "h-full w-[200px] footer flex flex-col items-center px-2 pb-3",
        className
      )}
    >
      <div className="footer-initials h-[40%] flex flex-col justify-center select-none">
        RS.
      </div>
      <div className="text-center text-sm grow pt-6">
        Learning new things. One day at a time.
      </div>
      <div className="text-center mb-3">
        Designed and programmed by yours truly.
      </div>
      <div className="text-center text-xs w-full mb-2 flex flex-row justify-evenly">
        <a
          href="https://gist.githubusercontent.com/rohan843/85be345cb966cbad10405136643d1597/raw/3da93a91bef1db504808b1d3e359e08945f254ff/disclaimer.txt"
          className="underline"
          target="_blank"
          rel="noreferrer"
        >
          disclaimer
        </a>
        <a
          href="https://gist.githubusercontent.com/rohan843/b0125c40a2a82a9485f1fddb894a4d50/raw/35eaff2b6fe02cd20d5e488112c7d8fc8d96c31f/acknowledgements.txt"
          className="underline"
          target="_blank"
          rel="noreferrer"
        >
          acknowledgements
        </a>
      </div>
      <div className="text-center text-xs">
        &copy; {new Date().getUTCFullYear()} Rohan Sharma
      </div>
    </div>
  );
}

export default Footer;
